import muster from '@dbk-legacy/muster';
import { constant } from '@dbk-legacy/muster/helpers';

//var is_ipad = navigator.userAgent.match(/ipad/i) != null

export default () => muster()
.path('app.global.deviceInfo.isTablet', {
      async get({ res }) {
        const obj = true;
        return res.value(obj);
      }
  })
.path('app.global.deviceInfo.width', {
      async get({ res }) {
        const width = 1920;
        return res.value(width);
      }
  })
.path('app.global.deviceInfo.height', {
      async get({ res }) {
        const height = 1080;
        return res.value(height);
      }
  });
